import { CardText, CardTitle, Row } from 'reactstrap';
import './styles.scss';
import { useEffect, useRef } from 'react';

export const ContractTerms: React.FC<{ onScrollEnd: () => void }> = ({
  onScrollEnd,
}) => {
  const termsRef = useRef<HTMLDivElement>(null);
  //
  useEffect(() => {
    const handleScroll = () => {
      // verifica se scroll se chegou ao fim
      if (termsRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = termsRef.current;
        const isEnd = scrollTop + clientHeight >= scrollHeight - 10; // Buffer de 10px
        if (isEnd) {
          onScrollEnd();
        }
      }
    };

    const updateContainerHeight = () => {
      if (termsRef.current) {
        termsRef.current.style.maxHeight = `${window.innerHeight * 0.7}px`; // Ajusta a altura para 70% da viewport
      }
    };
    updateContainerHeight();
    if (termsRef.current) {
      termsRef.current.addEventListener('scroll', handleScroll); // Atualiza nova altura do scroll
    }
    return () => {
      if (termsRef.current) {
        termsRef.current.removeEventListener('scroll', handleScroll);
      }
    };
  }, [onScrollEnd]);
  return (
    <>
      <article ref={termsRef} className="contract-terms mb-2 theme">
        <header className="entry-header mb-2">
          <CardTitle
            tag="h3"
            className="font-weight-bold font-md-2 text-center"
          >
            TERMOS E CONDIÇÕES DO CONTRATO DE PRESTAÇÃO DE SERVIÇOS DE
            CREDENCIAMENTO E ADESÃO DE ESTABELECIMENTO COMERCIAL AO SISTEMA DE
            PAGAMENTOS KOSMOS DA ULTRA PAYMENTS LTDA. Versão atualizada de
            01/09/2024
          </CardTitle>
        </header>

        <CardTitle tag="h4" className="font-weight-bold text-center">
          CONSIDERAÇÕES INICIAIS
        </CardTitle>

        <CardText className="mb-2">
          (a)
          <strong> ULTRA PAYMENTS LTDA</strong> (denominada neste ato ULTRA
          PAYMENTS) é uma provedora de serviços hospedada sob o domínio
          https://ultrapayments.com.br/, de propriedade da ULTRA PAYMENTS, com
          sede na Cidade de São Paulo, Estado de São Paulo, na Alameda Ministro
          Rocha Azevedo, 38 sala 403 – Bela Vista – CEP 01410-000, inscrita no
          CNPJ sob o nº 50.221.651/0001-80, com seus atos constitutivos
          registrados na Junta Comercial do Estado de São Paulo sob o NIRE
          3526107610-7, (<strong>“ULTRA PAYMENTS”</strong>);
        </CardText>

        <CardText className="mb-2">
          (b) O serviço oferecido pela <strong>ULTRA PAYMENTS</strong> é o de
          uma facilitadora de pagamento e conta corrente digital (wallet), que
          credencia pessoas jurídicas ou físicas que atuem no comércio em geral,
          via internet ou através de leitores móveis que se utilizam de
          smartphones, tablets ou telefones celulares, via equipamentos POS
          (Point of Sale) ou TEF com PinPad, para que possam aceitar cartões de
          crédito, débitos e/ou PIX de seus respectivos clientes
          (“Estabelecimentos”). A <strong>ULTRA PAYMENTS</strong> estabelece uma
          relação comercial com seus Estabelecimentos, não sendo, sob nenhuma
          hipótese, uma relação de consumo, uma vez que o produto oferecido pela
          <strong>ULTRA PAYMENTS</strong> é utilizado pelos Estabelecimentos
          como insumo em suas respectivas atividades comerciais;
        </CardText>

        <CardText className="mb-2">
          (c) A <strong>ULTRA PAYMENTS</strong> não participa nem interfere, de
          qualquer forma, na negociação ou na efetivação de quaisquer operações
          comerciais entre os Estabelecimentos e seus respectivos clientes. A
          ULTRA PAYMENTS simplesmente disponibiliza uma ferramenta que processa
          o pagamento efetuado pelo cliente dos Estabelecimentos, englobando a
          captura dos dados da transação realizada via cartões de
          <strong>crédito</strong> de <strong>débito</strong> ou
          <strong>PIX</strong>
          bem como a gestão desses dados.
        </CardText>
        <CardText className="mb-2">
          (d) A <strong>ULTRA PAYMENTS</strong> poderá abrir uma conta corrente
          digital para a operação de recebimento e liquidação de PIX, bem como
          para a liquidação de transações de crédito e débito em nome de seus
          respectivos clientes (“Estabelecimentos”), respeitando as regras
          vigentes do BACEN para a operação de contas digitais.
        </CardText>

        <CardText tag="h4" className="font-weight-bold">
          1. ADESÃO E DEFINIÇÕES
        </CardText>

        <CardText className="mb-2">
          <strong>1.1.</strong> Após aceitação pelo Estabelecimento deste
          Contrato de Prestação de Serviços de Credenciamento e Adesão ao
          Sistema
          <strong>KOSMOS</strong> da <strong>ULTRA PAYMENTS</strong>
          (“Contrato”) e o pagamento das respectivas taxas (conforme estipulado
          na Seção 3, abaixo), a <strong>ULTRA PAYMENTS</strong> prestará ao
          Estabelecimento os serviços que lhe possibilitarão aceitar pagamento
          com cartão de crédito, de débito e PIX, utilizando aparelhos celulares
          compatíveis ("Aparelhos Celulares"), e/ou por meio da utilização de
          equipamento POS (Points of Sale), também conhecido como “maquininha”
          ou máquina para “passar” cartões de crédito e/ou débito (“POS”), ou
          ainda via integração TEF com PinPad, conta corrente digital (wallet),
          conforme a tecnologia disponibilizada pela{' '}
          <strong>ULTRA PAYMENTS</strong> (“Serviços”).
        </CardText>

        <CardText className="mb-2">
          <strong>1.2.</strong> A utilização dos Serviços implica na plena
          compreensão, aceitação e vinculação automática do Estabelecimento a
          este Contrato. Ao fazer uso de quaisquer dos Serviços e benefícios
          oferecidos pela <strong>ULTRA PAYMENTS</strong>, os Estabelecimentos
          concordam em respeitar e seguir todas as disposições aqui
          estabelecidas.
        </CardText>

        <CardText className="mb-2">
          <strong>1.2.1.</strong> A <strong>ULTRA PAYMENTS</strong> poderá
          modificar a qualquer momento este Contrato, visando ao seu
          aprimoramento e melhoria dos serviços prestados. Para obter a
          concordância e adesão do Estabelecimento às alterações, estas serão
          publicadas no site da <strong>ULTRA PAYMENTS</strong>, sendo que o
          próximo acesso de cada Estabelecimento no site será precedido de
          informação sobre os novos termos, ficando condicionado à aceitação e
          adesão do Estabelecimento. A não aceitação importará a extinção do
          vínculo contratual e a consequente negativa de acesso do
          Estabelecimento à área exclusiva do site destinada aos
          Estabelecimentos.
        </CardText>

        <CardText className="mb-2">
          <strong>1.2.2.</strong> A <strong>ULTRA PAYMENTS</strong> registrará
          os pagamentos recebidos na conta vinculada do Estabelecimento e pagará
          as somas relevantes com depósito em uma conta bancária especificada
          pelo Estabelecimento e/ou na conta digital aberta para este fim,
          respeitada eventual trava bancária a que o Estabelecimento estiver
          sujeito.
        </CardText>

        <CardText className="mb-2">
          <strong>1.2.3.</strong> Ao prestar os Serviços, a{' '}
          <strong>ULTRA PAYMENTS</strong> atuará como um "facilitador de
          pagamento", processando pagamentos que o Estabelecimento receber de
          seus clientes. Isso inclui coletar, analisar e conferir as informações
          geradas em relação a esses pagamentos.
        </CardText>

        <CardText tag="h4" className="font-weight-bold">
          1.3. DISPONIBILIDADE DOS SERVIÇOS
        </CardText>

        <CardText className="mb-2">
          <strong>1.3.1.</strong> Embora a <strong>ULTRA PAYMENTS</strong>{' '}
          envide seus esforços para garantir que os Serviços estejam normalmente
          disponíveis por 24 (vinte e quatro) horas por dia, não se
          responsabilizará por eventual indisponibilidade dos Serviços devido a
          falhas no sistema, manutenção, reparos ou por razões além de seu
          controle, sobretudo em caso fortuito ou força maior.
        </CardText>

        <CardText className="mb-2">
          <strong>1.3.2.</strong> A <strong>ULTRA PAYMENTS</strong> envidará
          esforços para notificar o Estabelecimento com antecedência sobre
          operações planejadas de manutenção ou reparos que possam resultar na
          suspensão dos Serviços.
        </CardText>

        <CardText className="mb-2">
          <strong>1.3.3.</strong> A <strong>ULTRA PAYMENTS</strong> não se
          responsabilizará pela conectividade com a internet exigida para
          funcionamento de dispositivos como celular, tablet, POS ou TEF PinPad.
        </CardText>

        <CardText tag="h4" className="font-weight-bold">
          1.4. Cadastramento
        </CardText>
        <CardText className="mb-2">
          1.4.1. Após aceitar termos e condições deste Contrato, mediante a
          comprovação e aprovação da autenticidade dos documentos encaminhados
          pelo Estabelecimento – conforme instruções dadas pela{' '}
          <strong>ULTRA PAYMENTS</strong> –, a<strong>ULTRA PAYMENTS</strong>{' '}
          criará uma conta no aplicativo Kosmos para utilizar os serviços.
          Durante o processo de cadastramento, o Estabelecimento precisará
          fornecer informações, incluindo, porém não se limitando a, o seu nome,
          endereço, endereço de e-mail, número de telefone, detalhes da conta
          bancária e, quando necessário, o nome fantasia, a razão social da
          pessoa jurídica, número de inscrição no CNPJ, tipo/categoria do
          negócio, CNAE, cartão CNPJ, endereço completo do negócio, contrato
          social, declaração de faturamento, comprovante de endereço, declaração
          de patrimônio, declaração de capital social, foto do rosto, documento
          com foto, nome completo e data de nascimento de todos os sócios,
          procuração de pleno poder (quando aplicável), assim como o
          preenchimento do Termo de Credenciamento ao sistema da{' '}
          <strong>ULTRA PAYMENTS</strong>.
        </CardText>
        <CardText className="mb-2">
          1.4.2. O Estabelecimento concorda que: (i) as informações que fornece
          no processo de cadastramento serão precisas, completas e atualizadas;
          e (ii) notificará a <strong>ULTRA PAYMENTS</strong> imediatamente a
          respeito de quaisquer alterações/atualizações dos dados cadastrados,
          em especial, sede, objeto social e quadro societário, sob pena de
          descredenciamento a exclusivo critério da
          <strong>ULTRA PAYMENTS</strong>.
        </CardText>
        <CardText className="mb-2">
          1.4.3. Caso qualquer informação fornecida no cadastramento seja
          imprecisa ou esteja incompleta, tal fato poderá atrasar ou interromper
          os Serviços prestados ao Estabelecimento, não cabendo qualquer tipo de
          responsabilidade à<strong>ULTRA PAYMENTS</strong> por eventuais danos
          causados ao Estabelecimento, bem como poderá ensejar o
          descredenciamento do Estabelecimento a exclusivo critério da{' '}
          <strong>ULTRA PAYMENTS</strong>.
        </CardText>
        <CardText className="mb-2">
          1.4.4. O cadastramento ocorrerá mediante inscrição no sistema Kosmos
          da
          <strong>ULTRA PAYMENTS</strong>, com e-mail próprio, escolhendo a
          respectiva senha, de preferência senha diversa do e-mail em questão,
          para maior segurança do Estabelecimento, sendo de sua responsabilidade
          garantir que estas informações e outras informações de login sejam
          armazenadas de maneira segura. O Estabelecimento concorda em manter
          tais informações da conta de tal modo a permanecerem inacessíveis a
          pessoas não autorizadas. As informações da conta são pessoais e não
          poderão ser transferidas ou utilizadas por ninguém, exceto pelo
          Estabelecimento. O Estabelecimento deverá alterar sua credencial de
          acesso ou comunicar à <strong>ULTRA PAYMENTS</strong>
          imediatamente caso suspeite de algum acesso não autorizado. A
          <strong>ULTRA PAYMENTS</strong> não se responsabiliza por eventuais
          consequências do mau uso da senha de acesso.
        </CardText>
        <CardText className="mb-2">
          1.4.5. O Estabelecimento não terá permissão para processar nenhuma
          transação até que a abertura de sua conta seja autorizada pela{' '}
          <strong>ULTRA PAYMENTS</strong>.
        </CardText>

        <CardText tag="h4" className="font-weight-bold">
          1.5. VERIFICAÇÃO
        </CardText>

        <CardText className="mb-2">
          <strong>1.5.1.</strong> Uma vez concluído o processo de cadastramento,
          a <strong>ULTRA PAYMENTS</strong> realizará um processo de
          verificação, de acordo com suas obrigações regulamentares de prevenção
          e combate aos crimes de lavagem de dinheiro, terrorismo e seu
          financiamento, entre outros, conforme a Lei nº 9.613/1998 e
          regulamentações do <strong>COAF</strong>. Enquanto esse processo não
          for concluído, o Estabelecimento não poderá aceitar pagamentos.
        </CardText>

        <CardText className="mb-2">
          <strong>1.5.2.</strong> Para ajudar no processo de verificação, o
          Estabelecimento poderá ser solicitado a fornecer informações
          complementares sobre seus negócios e sócios, como comprovação de
          endereço ou registro de negócios. As informações devem ser fornecidas
          em até 3 (três) dias úteis após solicitação.
        </CardText>

        <CardText className="mb-2">
          <strong>1.5.3.</strong> A decisão sobre a verificação da identidade do
          Estabelecimento será a critério exclusivo da{' '}
          <strong>ULTRA PAYMENTS</strong>. Após verificação e aceitação, o
          Estabelecimento poderá aceitar pagamentos, respeitando limites e
          restrições estabelecidas.
        </CardText>

        <CardText className="mb-2">
          <strong>1.5.4.</strong> Os Estabelecimentos serão classificados
          conforme sua atividade comercial, o que determinará limites de
          transação, incluindo valor médio e máximo de transações típicas para o
          tipo de negócio.
        </CardText>

        <CardText className="mb-2">
          <strong>1.5.5.</strong> Pagamentos processados na conta do sistema
          Kosmos serão liquidados pela <strong>ULTRA PAYMENTS</strong> de acordo
          com o plano estipulado, respeitando eventuais travas bancárias.
        </CardText>

        <CardText className="mb-2">
          <strong>1.5.6.</strong> Caso os Limites estabelecidos sejam atingidos,
          o Estabelecimento não poderá aceitar novos pagamentos.
        </CardText>

        <CardText className="mb-2">
          <strong>1.5.7.</strong> Em circunstâncias excepcionais, a{' '}
          <strong>ULTRA PAYMENTS</strong>, a seu critério, poderá aumentar os
          Limites de um Estabelecimento.
        </CardText>

        <CardText tag="h4" className="font-weight-bold">
          1.6. EQUIPAMENTOS PARA UTILIZAÇÃO DOS SERVIÇOS
        </CardText>

        <CardText className="mb-2">
          <strong>1.6.1.</strong> Para utilizar os Serviços, o Estabelecimento
          deve possuir um leitor de cartão e um dispositivo compatível
          (smartphone, tablet, POS ou automação TEF com PinPad), conforme
          tecnologia da <strong>ULTRA PAYMENTS</strong>.
        </CardText>

        <CardText className="mb-2">
          <strong>1.6.1.1.</strong> Detalhes sobre requisitos técnicos podem ser
          consultados no site{' '}
          <a href="https://ultrapayments.com.br" target="_blank">
            https://ultrapayments.com.br
          </a>
          .
        </CardText>

        <CardText className="mb-2">
          <strong>1.6.2.</strong> O Estabelecimento não poderá usar dispositivos
          modificados contrariamente às diretrizes do fabricante (ex.:
          “jailbreak”).
        </CardText>

        <CardText className="mb-2">
          <strong>1.6.3.</strong> O uso de dispositivos está sujeito a contratos
          com terceiros, como operadoras de celular. A{' '}
          <strong>ULTRA PAYMENTS</strong> não se responsabiliza por
          incompatibilidades.
        </CardText>

        <CardText className="mb-2">
          <strong>1.6.4.</strong> O leitor de cartão ou POS será, geralmente,
          propriedade da <strong>ULTRA PAYMENTS</strong> e cedido sob locação ou
          comodato. O Estabelecimento deverá devolvê-los conforme os termos
          contratuais aplicáveis.
        </CardText>

        <CardText className="mb-2">
          <strong>1.6.5.</strong> Caso o leitor de cartão seja adquirido pelo
          Estabelecimento, ele poderá ser usado apenas para os Serviços da{' '}
          <strong>ULTRA PAYMENTS</strong>.
        </CardText>

        <CardText className="mb-2">
          <strong>1.6.6.</strong> Os equipamentos devem ser utilizados
          exclusivamente para a prestação dos Serviços, sendo vedados outros
          usos que possam configurar fraudes ou violações às regras do Sistema
          Brasileiro de Pagamentos.
        </CardText>

        <CardText tag="h4" className="font-weight-bold">
          1.7. CARTÕES ACEITOS
        </CardText>

        <CardText className="mb-2">
          <strong>1.7.1.</strong> O Estabelecimento poderá aceitar pagamentos
          apenas com cartões relacionados no site da{' '}
          <strong>ULTRA PAYMENTS</strong>, desde que estejam credenciados. A
          relação de cartões aceitos pode ser alterada a qualquer momento.
        </CardText>

        <CardText tag="h4" className="font-weight-bold">
          1.8. REGRAS DE BANDEIRA DE CARTÃO
        </CardText>

        <CardText className="mb-2">
          <strong>1.8.1.</strong> O Estabelecimento poderá utilizar os Serviços
          apenas de acordo com as regras das{' '}
          <strong>BANDEIRAS ADMITIDAS</strong> e que tenham sido objeto de
          credenciamento pela <strong>ULTRA PAYMENTS</strong>. A{' '}
          <strong>ULTRA PAYMENTS</strong> não armazena os dados dos cartões dos
          clientes, exceto o necessário para vinculação do cliente ao cartão
          utilizado.
        </CardText>

        <CardText className="mb-2">
          <strong>1.8.2.</strong> O Estabelecimento não poderá armazenar dados
          de cartões de forma diversa para reutilização futura. Qualquer prática
          contrária será reprimida, podendo levar ao descredenciamento do
          Estabelecimento, a critério exclusivo da{' '}
          <strong>ULTRA PAYMENTS</strong>.
        </CardText>

        <CardText tag="h4" className="font-weight-bold">
          1.9. RESTRIÇÕES E LIMITAÇÕES DE USO
        </CardText>

        <CardText className="mb-2">
          <strong>1.9.1.</strong> Além dos limites descritos no item 1.5.4., o
          Estabelecimento concorda em utilizar os Serviços conforme as seguintes
          restrições:
          <ul>
            <li>
              Aceitar pagamentos somente em conformidade com as leis e
              regulamentos aplicáveis.
            </li>
            <li>
              Não utilizar os Serviços para aceitar pagamentos de produtos ou
              serviços de segmentos não autorizados no cadastro inicial sem
              aprovação da <strong>ULTRA PAYMENTS</strong>.
            </li>
            <li>
              Não aceitar pagamentos de cartões cujo titular seja o próprio
              Estabelecimento ou sua empresa.
            </li>
            <li>
              Não atuar como intermediário de pagamento, agregador ou revendedor
              dos Serviços.
            </li>
          </ul>
        </CardText>

        <CardText className="mb-2">
          <strong>1.9.2.</strong> O uso dos Serviços implica o cumprimento das
          regras das <strong>BANDEIRAS ADMITIDAS</strong>, incluindo
          verificações adicionais realizadas pela{' '}
          <strong>ULTRA PAYMENTS</strong> ou por terceiros credenciados, como:
          <ul>
            <li>Solicitação de documentos adicionais.</li>
            <li>Avaliação de instalações e regularidade das práticas.</li>
          </ul>
        </CardText>

        <CardText className="mb-2">
          <strong>1.9.3.</strong> A verificação de documentos pela{' '}
          <strong>ULTRA PAYMENTS</strong> não confere atestado de regularidade e
          não exclui outras verificações necessárias.
        </CardText>

        <CardText tag="h4" className="font-weight-bold">
          1.10. OBRIGAÇÕES DE SEGURANÇA DO ESTABELECIMENTO
        </CardText>

        <CardText className="mb-2">
          <strong>1.10.1.</strong> O Estabelecimento deve tomar precauções para
          manter a segurança de seus equipamentos e dados, incluindo login e
          senha da conta na <strong>ULTRA PAYMENTS</strong>.
        </CardText>

        <CardText className="mb-2">
          <strong>1.10.2.</strong> Caso os equipamentos ou dados de segurança
          sejam perdidos ou roubados, o Estabelecimento deve notificar a{' '}
          <strong>ULTRA PAYMENTS</strong> imediatamente pelo canal de
          atendimento indicado no site.
        </CardText>

        <CardText className="mb-2">
          <strong>1.10.3.</strong> Se não houver notificação prévia sobre
          acessos indevidos, a <strong>ULTRA PAYMENTS</strong> processará
          normalmente as transações, não se responsabilizando por eventuais
          prejuízos.
        </CardText>

        <CardText className="mb-2">
          <strong>1.10.4.</strong> O Estabelecimento deve verificar a
          titularidade dos cartões apresentados. Caso tenha dúvidas, deve
          recusar a transação.
        </CardText>

        <CardText className="mb-2">
          <strong>1.10.5.</strong> Suspeitas de fraude devem ser reportadas à{' '}
          <strong>ULTRA PAYMENTS</strong>, sendo o Estabelecimento responsável
          por penalidades de transações fraudulentas.
        </CardText>

        <CardText tag="h4" className="font-weight-bold">
          1.11. BENEFÍCIOS
        </CardText>

        <CardText className="mb-2">
          <strong>1.11.1.</strong> A <strong>ULTRA PAYMENTS</strong> poderá
          oferecer benefícios adicionais, como adesão a planos de seguro ou
          segurança patrimonial, por meio de parceiros. Tais benefícios serão
          regulados por contratos específicos, sem responsabilidade direta da{' '}
          <strong>ULTRA PAYMENTS</strong>.
        </CardText>

        <CardText tag="h4" className="font-weight-bold">
          2. TRANSAÇÃO DO PAGAMENTO
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          2.1. Repasse
        </CardText>

        <CardText className="mb-2">
          <strong>2.1.1.</strong> O Estabelecimento reconhece que a utilização
          dos Serviços e sua adesão ao sistema da
          <strong>ULTRA PAYMENTS</strong> implica na contratação desta para
          administrar a liquidação e também da bandeira emissora do cartão para
          cobrança do valor da transação junto ao portador. O valor será
          repassado ao Estabelecimento no prazo acordado, deduzidas as taxas e
          encargos aplicáveis, desde que a transação tenha sido realizada
          conforme o Contrato.
        </CardText>

        <CardText className="mb-2">
          <strong>2.1.2.</strong> A <strong>ULTRA PAYMENTS</strong> realizará o
          repasse do valor, descontando taxas, aluguel de equipamento (Leitor de
          Cartão/POS), por meio de depósito no domicílio bancário cadastrado. O
          depósito será feito à vista ou conforme o parcelamento, respeitando
          eventuais travas bancárias aplicáveis ao Estabelecimento.
        </CardText>

        <CardText className="mb-2">
          <strong>2.1.3.</strong> O crédito do repasse no domicílio bancário do
          Estabelecimento comprova a quitação das obrigações pecuniárias
          decorrentes da transação, exceto em casos de cancelamento ou estorno
          previstos neste contrato.
        </CardText>

        <CardText className="mb-2">
          <strong>2.1.4.</strong> Caso o Estabelecimento não cumpra as
          obrigações contratuais, o valor da transação poderá ser retido pela
          <strong>ULTRA PAYMENTS</strong> ou estornado. Essa regra se aplica
          também nas seguintes situações:
          <ul>
            <li>
              Se a transação for cancelada pelo Estabelecimento ou pela{' '}
              <strong>ULTRA PAYMENTS</strong> a pedido do Estabelecimento.
            </li>
            <li>
              Se houver controvérsia sobre os bens ou serviços fornecidos e não
              resolvida entre o Estabelecimento e seu cliente.
            </li>
            <li>
              Se houver ordem legítima impedindo o repasse ou determinando
              bloqueio/crédito judicial.
            </li>
            <li>
              Se a transação for considerada suspeita ou irregular, conforme
              escalas das bandeiras de cartões.
            </li>
          </ul>
        </CardText>

        <CardText className="mb-2">
          <strong>2.1.5.</strong> Em caso de cancelamento/estorno, o valor da
          transação será restituído pela <strong>ULTRA PAYMENTS</strong>
          atualizado pelo IGP-M/FGV, acrescido de juros de 1% ao mês e encargos
          operacionais.
        </CardText>

        <CardText className="mb-2">
          <strong>2.1.6.</strong> O ajuste de débitos será realizado na agenda
          financeira do Estabelecimento dentro de 12 meses, ou 24 meses no caso
          de serviços não prestados. Débitos poderão ser realizados a qualquer
          momento em caso de falência ou insolvência.
        </CardText>

        <CardText className="mb-2">
          <strong>2.1.7.</strong> Caso não haja fundos suficientes, a{' '}
          <strong>ULTRA PAYMENTS</strong> poderá utilizar meios legais para
          cobrança, sendo o Estabelecimento responsável pelos custos envolvidos.
          Os fundos serão transferidos ao Estabelecimento conforme programação e
          só estarão disponíveis após a transferência.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          2.2. Uso Não Autorizado ou Ilegal por Titulares de Cartão
        </CardText>

        <CardText className="mb-2">
          <strong>2.2.1.</strong> O risco de uso não autorizado ou ilegal por
          titulares de cartão recai sobre o Estabelecimento, que será
          responsável por quaisquer danos a terceiros e à{' '}
          <strong>ULTRA PAYMENTS</strong>.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          2.3. Restituições
        </CardText>

        <CardText className="mb-2">
          <strong>2.3.1.</strong> Restituições serão permitidas somente pela{' '}
          <strong>CONTA ULTRA PAYMENTS</strong> do Estabelecimento e se
          atenderem aos seguintes critérios:
          <ul>
            <li>A restituição deve ser do valor total da transação.</li>
            <li>
              Deve ser iniciada em até 30 dias corridos da data da transação.
            </li>
            <li>O cartão utilizado deve estar válido.</li>
            <li>
              Deve haver saldo suficiente na agenda financeira do
              Estabelecimento.
            </li>
          </ul>
        </CardText>

        <CardText className="mb-2">
          <strong>2.3.2.</strong> Para processar uma restituição, o
          Estabelecimento deve enviar solicitação por e-mail para
          suporte@ultrapayments.com.br ou realizar contato telefônico pelo
          número indicado no site, indicando a transação no histórico do sistema
          Kosmos. A solicitação será considerada recebida no momento do envio
          completo das informações.
        </CardText>

        <CardText className="mb-2">
          <strong>2.3.3.</strong> O valor da transação será creditado na fatura
          do portador do cartão conforme prazos do emissor do cartão.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          2.4. CHARGEBACK/Contestação da Venda
        </CardText>

        <CardText className="mb-2">
          <strong>2.4.1.</strong> As emissoras de cartão podem recusar ou anular
          uma transação comprovadamente incorreta ou inválida, por meio do
          processo de CHARGEBACK. Caso uma transação processada pela{' '}
          <strong>CONTA ULTRA PAYMENTS</strong> seja identificada como inválida
          pela emissora do cartão, o Estabelecimento será responsável por
          restituir o valor, exceto em casos de erro exclusivo da ULTRA
          PAYMENTS. A ULTRA PAYMENTS poderá auxiliar o Estabelecimento em
          controvérsias com as emissoras.
        </CardText>

        <CardText className="mb-2">
          <strong>2.4.2.</strong> Se a <strong>ULTRA PAYMENTS</strong> suspeitar
          de fraude em uma transação com CHARGEBACK, poderá suspender a conta do
          Estabelecimento e reter valores até a resolução da situação. Uma
          notificação prévia será enviada ao Estabelecimento.
        </CardText>

        <CardText className="mb-2">
          <strong>2.4.3.</strong> A <strong>ULTRA PAYMENTS</strong> não
          realizará o repasse ou estorno de valores referentes a contestações de
          transações. Débitos por CHARGEBACK serão cobrados diretamente da conta
          do Estabelecimento.
        </CardText>

        <CardText className="mb-2">
          <strong>2.4.4.</strong> O Estabelecimento deve fornecer a nota fiscal
          de vendas ou serviços em até 3 dias úteis quando solicitado pela{' '}
          <strong>ULTRA PAYMENTS</strong>. A ausência desse documento poderá
          resultar em débitos futuros ou emissão de boleto para cobertura do
          CHARGEBACK.
        </CardText>

        <CardText className="mb-2">
          <strong>2.4.5.</strong> Caso um cliente cancele ou conteste uma
          transação já paga ao Estabelecimento, os valores correspondentes serão
          debitados da <strong>CONTA ULTRA PAYMENTS</strong> do Estabelecimento.
          Se não houver saldo suficiente, os débitos serão realizados em futuros
          ingressos ou créditos.
        </CardText>

        <CardText className="mb-2">
          <strong>2.4.6.</strong> Em caso de inadimplência referente ao
          CHARGEBACK, a <strong>ULTRA PAYMENTS</strong> poderá:
          <ul>
            <li>
              Aplicar multa de 2% sobre o valor devido, com juros e atualização
              monetária pelo IGP-M/FGV.
            </li>
            <li>
              Debitar valores de movimentações futuras na conta do
              Estabelecimento.
            </li>
            <li>
              Registrar inadimplência nos sistemas e órgãos de proteção ao
              crédito.
            </li>
            <li>
              Encaminhar a cobrança para agências externas ou judicializar a
              cobrança.
            </li>
          </ul>
        </CardText>

        <CardText className="mb-2">
          <strong>2.4.7.</strong> Transações suspeitas podem ter fundos retidos
          por até 6 meses, salvo comprovação de regularidade.
        </CardText>

        <CardText className="mb-2">
          <strong>2.4.8.</strong> O Estabelecimento deve armazenar documentos
          que comprovem vendas ou serviços por 1 ano. Estes serão utilizados
          para justificar contestação de CHARGEBACKs.
        </CardText>

        <CardText className="mb-2">
          <strong>2.4.9.</strong> Mesmo apresentando documentação, o
          Estabelecimento está ciente de que credenciadoras, bandeiras ou bancos
          emissores podem rejeitá-la, resultando em débito dos valores
          contestados.
        </CardText>

        <CardText className="mb-2">
          <strong>2.4.10.</strong> A responsabilidade por falhas na entrega de
          produtos ou serviços é exclusiva do Estabelecimento.
        </CardText>

        <CardText className="mb-2">
          <strong>2.4.11.</strong> O encerramento da conta do Estabelecimento
          não impede a análise de CHARGEBACKs pela{' '}
          <strong>ULTRA PAYMENTS</strong>, que poderá reter recursos para
          proteger-se de riscos. Obrigações do Estabelecimento permanecem mesmo
          após o encerramento.
        </CardText>

        <CardText className="mb-2">
          <strong>2.4.12.</strong> Caso ocorra débito devido a CHARGEBACK, o
          Estabelecimento responderá pelo valor e custos decorrentes. A{' '}
          <strong>ULTRA PAYMENTS</strong> poderá buscar reembolso judicial ou
          extrajudicialmente, incluindo honorários advocatícios, se necessário.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          2.4.13. Cancelamento de Conta
        </CardText>

        <CardText className="mb-2">
          Caso a conta do sistema da <strong>ULTRA PAYMENTS</strong> do
          Estabelecimento fique inativa por mais de 180 (cento e oitenta) dias,
          a <strong>ULTRA PAYMENTS</strong> poderá, a seu exclusivo critério,
          cancelar e rescindir a conta e o presente Contrato. O Estabelecimento
          será notificado com 30 (trinta) dias de antecedência sobre a intenção
          de encerramento da conta. Após o encerramento, o Estabelecimento não
          poderá acessar os detalhes de sua conta, e seu cadastro no site será
          igualmente cancelado. Contudo, os vencimentos futuros serão liquidados
          normalmente, com os depósitos na conta bancária do Estabelecimento,
          mesmo após o cancelamento.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          2.4.14. Taxas e Multas por CHARGEBACK
        </CardText>

        <CardText className="mb-2">
          No caso de ocorrência de CHARGEBACK, todos os valores referentes às
          taxas da transação e fees cobrados pela{' '}
          <strong>ULTRA PAYMENTS</strong>, incluindo os serviços de gateway,
          deverão ser integralmente pagos pelo Estabelecimento, com a adição de
          multa de R$ 50,00 (cinquenta reais) e/ou 6% sobre o valor da transação
          para cada CHARGEBACK ocorrido.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          2.4.15. Serviço de Aviso de CHARGEBACK
        </CardText>

        <CardText className="mb-2">
          Caso ocorra CHARGEBACK, a <strong>ULTRA PAYMENTS</strong> poderá
          cobrar, pelo serviço de aviso de CHARGEBACK e encerramento de disputa,
          valores em dólares americanos que variam de US$ 6,50 a US$ 35,00 por
          cada CHARGEBACK ocorrido. Os valores serão convertidos para reais (R$)
          com base no câmbio do Dólar Comercial Oficial na data da ocorrência.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          2.5. Plano de Antecipação
        </CardText>

        <CardText className="mb-2">
          <strong>2.5.1.</strong> Caso o Estabelecimento deseje negociar seus
          recebíveis, deverá solicitar junto à <strong>ULTRA PAYMENTS</strong>,
          conforme disponibilidade e condições aplicáveis. Qualquer negociação,
          antecipação ou cessão de recebíveis estará sujeita à anuência da{' '}
          <strong>ULTRA PAYMENTS</strong>, que verificará a viabilidade da
          operação.
        </CardText>

        <CardText className="mb-2">
          <strong>2.5.2.</strong> Caso a <strong>ULTRA PAYMENTS</strong>{' '}
          suspeite de alguma transação após anuência da negociação de
          recebíveis, poderá reter o fluxo de recursos por até 180 (cento e
          oitenta) dias úteis para validação das informações, e o
          Estabelecimento deverá fornecer todas as informações solicitadas.
        </CardText>

        <CardText className="mb-2">
          <strong>2.5.3.</strong> O Estabelecimento não poderá negociar seus
          recebíveis com terceiros sem a prévia e expressa autorização da{' '}
          <strong>ULTRA PAYMENTS</strong>.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          2.6. Direitos de Compensação
        </CardText>

        <CardText className="mb-2">
          <strong>2.6.1.</strong> A <strong>ULTRA PAYMENTS</strong> realizará a
          compensação das transações de cartão de crédito ou débito após a
          dedução de comissões, taxas e encargos aplicáveis. O valor transferido
          ao Estabelecimento será o volume bruto da transação, exceto pelas
          deduções.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          2.7. Comprovantes das Transações
        </CardText>

        <CardText className="mb-2">
          <strong>2.7.1.</strong> A <strong>ULTRA PAYMENTS</strong> manterá os
          comprovantes das transações realizadas pelo Estabelecimento sem custos
          adicionais. O Estabelecimento não será responsável pela manutenção
          desses dados, que estarão disponíveis para consulta no site
          ultrapayments.com.br.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          2.8. Extratos Mensais
        </CardText>

        <CardText className="mb-2">
          <strong>2.8.1.</strong> A <strong>ULTRA PAYMENTS</strong> fornecerá ao
          Estabelecimento um extrato mensal com as seguintes informações:
          <ul>
            <li>
              Referência para identificar as transações realizadas no mês.
            </li>
            <li>
              Valor das transações em reais (moeda corrente na{' '}
              <strong>CONTA ULTRA PAYMENTS</strong> do Estabelecimento).
            </li>
            <li>Repartição dos custos das transações realizadas.</li>
            <li>Data de valor do crédito.</li>
          </ul>
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          3. TAXAS E ENCARGOS
        </CardText>

        <CardText className="mb-2">
          <strong>3.1.</strong> Em decorrência da afiliação e dos serviços
          prestados pela <strong>ULTRA PAYMENTS</strong> ao Estabelecimento, o
          Estabelecimento concorda em pagar uma taxa de transação que remunera
          os serviços prestados pela indústria de cartões/bandeiras e pela{' '}
          <strong>ULTRA PAYMENTS</strong> (“
          <strong>TAXA E/OU TARIFA DE TRANSAÇÃO</strong>”).
        </CardText>

        <CardText className="mb-2">
          <strong>3.2.</strong> O valor da{' '}
          <strong>TAXA E/OU TARIFA DE TRANSAÇÃO</strong> será abatido
          automaticamente do valor bruto da transação e poderá ser diferente em
          função do tipo de transação, tipo de meio de pagamento utilizado,
          segmento de atuação do Estabelecimento, e/ou forma de captura de
          dados.
        </CardText>

        <CardText className="mb-2">
          <strong>3.3.</strong> O Estabelecimento será responsável, além do
          pagamento da <strong>TAXA E/OU TARIFA DE TRANSAÇÃO</strong>, pelo
          pagamento dos seguintes encargos, conforme os valores em vigor quando
          do fato gerador e conforme venham a ser exigidos pela{' '}
          <strong>ULTRA PAYMENTS</strong>:
          <ul>
            <li>
              <strong>
                Valor de aquisição ou de aluguel do Leitor de Cartões e/ou do
                equipamento POS:
              </strong>{' '}
              preço a ser pago pela compra ou locação do Leitor de Cartões e/ou
              do equipamento POS da <strong>ULTRA PAYMENTS</strong>, conforme o
              caso.
            </li>
            <li>
              <strong>Taxa de Antecipação:</strong> taxa cobrada para antecipar
              os recebíveis de transações para o Estabelecimento, quando
              aplicável.
            </li>
            <li>
              <strong>Taxa de Liquidação:</strong> taxa devida pela liquidação
              dos valores das transações no domicílio bancário do
              Estabelecimento. Essa taxa incide sobre cada liquidação realizada
              no domicílio bancário do Estabelecimento.
            </li>
            <li>
              <strong>Taxa de Serviço:</strong> taxa devida eventualmente a
              parceiro da <strong>ULTRA PAYMENTS</strong> pela prestação de
              serviço, o que será acompanhado da respectiva descrição dos
              serviços prestados pelo parceiro.
            </li>
            <li>
              <strong>Tarifa de Saque:</strong> tarifa devida pela Transferência
              (TED ou PIX) dos recebíveis para a conta bancária do
              Estabelecimento.
            </li>
            <li>
              <strong>Outras Taxas e/ou Tarifas:</strong> demais taxas e/ou
              tarifas devidas, a exemplo da mensalidade, mediante prévia
              informação e aprovação pelo Estabelecimento.
            </li>
          </ul>
        </CardText>

        <CardText className="mb-2">
          A <strong>ULTRA PAYMENTS</strong> se reserva ao direito de alterar as
          taxas e encargos aplicados ao Estabelecimento mencionados nesta Seção
          3. O Estabelecimento será notificado sobre tais alterações com
          antecedência mínima de 30 (trinta) dias da data em que as alterações
          entrarem em vigor, ou em período inferior, caso os demais
          participantes do arranjo imponham alterações em período inferior a 30
          (trinta) dias. O Estabelecimento deverá aceitar as alterações antes de
          processar quaisquer transações futuras. Caso não queira aceitar
          qualquer alteração nas taxas, o Estabelecimento terá o direito de
          rescindir o presente Contrato. O uso continuado dos Serviços pelo
          Estabelecimento após a notificação das alterações será considerado
          como uma confirmação de sua aceitação das alterações nas taxas e
          encargos.
        </CardText>

        <CardText className="mb-2">
          As taxas e encargos aplicados ao Estabelecimento mencionados nesta
          Seção 3 serão determinadas casuisticamente, de acordo com os
          parâmetros mencionados neste Contrato e poderão ser consultados no
          Site, na página de acesso exclusivo do Estabelecimento, bem como
          integrarão as informações presentes no Termo de Credenciamento.
        </CardText>

        <CardText className="mb-2">
          <strong>3.5.1.</strong> Nos valores mencionados no Termo de
          Credenciamento estão incluídos todos os tributos incidentes sobre o
          serviço prestado. Caso haja qualquer alteração nas alíquotas de tais
          impostos, a criação ou a extinção de tributos incidentes em referidas
          operações ou criação de novos, os preços pactuados no Termo de
          Credenciamento serão reajustados, para mais ou para menos,
          proporcionalmente aos efeitos causados por tais eventos, de comum
          acordo entre as Partes.
        </CardText>

        <CardText className="mb-2">
          <strong>3.6.</strong> Os valores mencionados no Termo de
          Credenciamento serão reajustados a cada 12 (doze) meses pelo IGPM-FGV
          (Índice Geral de Preços da Fundação Getúlio Vargas), obrigando as
          Partes, desde já, a manter o equilíbrio econômico do Contrato. A{' '}
          <strong>ULTRA PAYMENTS</strong> poderá, a seu exclusivo critério, não
          promover o reajuste mencionado neste item 3.6.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          4. SUSPENSÃO E EXTINÇÃO DO CONTRATO
        </CardText>

        <CardText className="mb-2">
          <strong>4.1.</strong> O presente Contrato gerará plenos efeitos até
          que seja rescindido pelo Estabelecimento ou pela{' '}
          <strong>ULTRA PAYMENTS</strong>, de acordo com o mencionado nesta
          Seção 4.
        </CardText>

        <CardText className="mb-2">
          <strong>4.2. Suspensão dos Serviços</strong>
        </CardText>

        <CardText className="mb-2">
          <strong>4.2.1.</strong> A <strong>ULTRA PAYMENTS</strong> se reserva
          ao direito de suspender imediata e indefinidamente a prestação dos
          Serviços ao Estabelecimento e a bloquear o acesso à sua conta{' '}
          <strong>ULTRA PAYMENTS</strong> sem aviso prévio, caso acredite
          razoavelmente que o Estabelecimento:
          <ul>
            <li>
              tenha nos fornecido informações falsas, imprecisas, incompletas ou
              enganosas quando solicitado pela <strong>ULTRA PAYMENTS</strong>{' '}
              ou quando do fornecimento das informações para preenchimento de
              seus dados cadastrais;
            </li>
            <li>tenha violado os termos do presente Contrato;</li>
            <li>
              imponha à <strong>ULTRA PAYMENTS</strong> um risco de crédito ou
              de fraude inaceitável, segundo critérios da própria{' '}
              <strong>ULTRA PAYMENTS</strong>;
            </li>
            <li>
              esteja fazendo uso dos Serviços em violação da lei ou regulamento
              aplicável das regras das indústrias de cartões; ou
            </li>
            <li>esteja envolvido em condutas fraudulentas ou ilegais.</li>
          </ul>
        </CardText>

        <CardText className="mb-2">
          <strong>4.2.2.</strong> A <strong>ULTRA PAYMENTS</strong> notificará o
          Estabelecimento com antecedência a respeito de sua intenção em
          suspender os Serviços e apresentará as razões para tanto.
        </CardText>

        <CardText className="mb-2">
          <strong>4.3. Resilição por Parte do Estabelecimento</strong>
        </CardText>

        <CardText className="mb-2">
          <strong>4.3.1.</strong> O Estabelecimento poderá rescindir o presente
          Contrato a qualquer momento, encerrando sua conta do sistema da{' '}
          <strong>ULTRA PAYMENTS</strong>, mediante notificação com antecedência
          mínima de 30 (trinta) dias, hipótese na qual deverão ser quitados
          eventuais débitos existentes em favor da{' '}
          <strong>ULTRA PAYMENTS</strong>.
        </CardText>

        <CardText className="mb-2">
          <strong>4.4. Resilição por parte da ULTRA PAYMENTS</strong>
        </CardText>

        <CardText className="mb-2">
          <strong>4.4.1.</strong> A <strong>ULTRA PAYMENTS</strong> poderá
          rescindir o presente Contrato a qualquer momento por meio de uma
          notificação por escrito com antecedência mínima de 30 (trinta) dias da
          resilição, sem prejuízo das hipóteses descritas no item 4.2.1., acima.
        </CardText>

        <CardText className="mb-2">
          <strong>4.5. Consequências da rescisão do Contrato</strong>
        </CardText>

        <CardText className="mb-2">
          <strong>4.5.1.</strong> Todas as transações realizadas na conta do
          sistema da <strong>ULTRA PAYMENTS</strong> do Estabelecimento, que
          estejam de acordo com as determinações deste Contrato e com as regras
          aplicáveis à indústria de cartões, que sejam anteriores à data de
          rescisão, serão processadas e liquidadas pela{' '}
          <strong>ULTRA PAYMENTS</strong>.
        </CardText>

        <CardText className="mb-2">
          <strong>4.5.2.</strong> A rescisão do presente Contrato não afetará
          nenhum direito e/ou obrigação que poderão ser acumulados antes da
          rescisão ou término deste Contrato. As obrigações de qualquer das
          partes estabelecidas no presente Contrato com a intenção de
          permanecerem após a rescisão continuarão em pleno vigor e gerarão
          todos os efeitos, não obstante a rescisão.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          5. PROTEÇÃO DE DADOS
        </CardText>

        <CardText className="mb-2">
          <strong>5.1.</strong> Cada uma das partes se obriga, sob pena de
          indenização por perdas e danos e aplicação de multa, a manter em
          absoluto sigilo e confidencialidade, usando somente para os fins deste
          Contrato, todas as informações, dados ou especificações a que tiver
          acesso ou que porventura venha a conhecer ou ter ciência sobre as
          transações, clientes do Estabelecimento, dados de cartões dos clientes
          e dos meios de pagamento e condições comerciais deste Contrato, sem
          prejuízo das obrigações de revelação ou dos reportes exigidos em lei
          ou por ordem judicial. Neste ato, o Estabelecimento expressamente
          autoriza que a <strong>ULTRA PAYMENTS</strong> preste às autoridades
          competentes como, por exemplo, Banco Central do Brasil, Receita
          Federal, Secretarias das Fazendas Estaduais, Secretarias de
          Arrecadação Municipais, Conselho de Controle de Atividades
          Financeiras, Polícia Federal etc., todas as informações que forem
          solicitadas com relação ao Estabelecimento e operações por ele
          executadas sob este Contrato, bem como informações a entidades que se
          destinem a controlar garantias que envolvam recebíveis.
        </CardText>

        <CardText className="mb-2">
          <strong>5.2.</strong> Salvo se disposto de forma diversa neste
          Contrato ou em lei, cada uma das partes se compromete a manter,
          conservar e guardar todas as informações, equipamentos e materiais que
          lhe sejam entregues ou a que tenha acesso da outra parte em
          decorrência do presente Contrato, em local absolutamente seguro e com
          acesso permitido somente a pessoas autorizadas, que também se obriguem
          a mantê-los em sigilo, nos termos aqui previstos.
        </CardText>

        <CardText className="mb-2">
          <strong>5.3.</strong> O Estabelecimento obriga-se a cumprir todos os
          requerimentos de segurança da informação definidos pela{' '}
          <strong>ULTRA PAYMENTS</strong>, pelas BANDEIRA ADMITIDAS e/ou pelo
          PCI COUNCIL, conforme versão mais atualizada disponível. Nesse
          sentido, o Estabelecimento deverá armazenar somente aqueles dados de
          transações, de clientes do Estabelecimento e de cartões dos clientes
          que venham a ser autorizados pelo sistema da{' '}
          <strong>ULTRA PAYMENTS</strong>. Essa obrigação de sigilo se manterá
          válida inclusive quando do término, por qualquer motivo, do Contrato.
          A não observância dos requerimentos mencionados nesta Seção sujeitará
          o Estabelecimento ao pagamento de indenização compatível com os
          prejuízos incorridos pela <strong>ULTRA PAYMENTS</strong> e às sanções
          e pagamento das multas específicas previstas nas normas e regulamento
          operacional da BANDEIRA ADMITIDA relacionada com Estabelecimento, sem
          prejuízo das demais medidas asseguradas em lei às partes e aos
          terceiros prejudicados.
        </CardText>

        <CardText className="mb-2">
          <strong>5.4.</strong> As obrigações de segurança de dados dispostas
          nesta Seção e definidas pelo PCI COUNCIL e/ou outros programas de
          segurança estabelecidos pelas BANDEIRAS ADMITIDAS e/ou pela{' '}
          <strong>ULTRA PAYMENTS</strong> se estendem aos prestadores de serviço
          e terceiros contratados pelo Estabelecimento ou colaboradores do
          Estabelecimento. O Estabelecimento obriga-se, quando solicitado, a
          executar por meios próprios ou a permitir a condução de auditorias
          pela <strong>ULTRA PAYMENTS</strong> ou terceiro por ela indicado, às
          custas do Estabelecimento, para fins de revisão dos procedimentos de
          segurança do Estabelecimento e prestadores de serviços, terceiros
          contratados e colaboradores.
        </CardText>

        <CardText className="mb-2">
          <strong>5.5. Direitos do Estabelecimento</strong>
        </CardText>

        <CardText className="mb-2">
          <strong>5.5.1.</strong> O Estabelecimento tem o direito de solicitar
          uma cópia das informações detidas pela <strong>ULTRA PAYMENTS</strong>{' '}
          sobre o Estabelecimento (para a qual a <strong>ULTRA PAYMENTS</strong>{' '}
          poderá cobrar uma taxa de administração) e corrigir qualquer
          informação imprecisa sobre o Estabelecimento.
        </CardText>

        <CardText className="mb-2">
          <strong>5.5.2.</strong> O Estabelecimento também tem o direito de
          solicitar que a <strong>ULTRA PAYMENTS</strong> não processe seus
          dados pessoais para fins de marketing.
        </CardText>

        <CardText className="mb-2">
          <strong>5.6. Consentimento</strong>
        </CardText>

        <CardText className="mb-2">
          <strong>5.6.1.</strong> Ao aceitar os termos deste Contrato, o
          Estabelecimento consente com a coleta, armazenamento e processamento
          de seus dados pessoais pela <strong>ULTRA PAYMENTS</strong>, de acordo
          com as disposições deste item 5.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          6. PROPRIEDADE INTELECTUAL
        </CardText>

        <CardText className="mb-2">
          <strong>6.1.</strong> Exceto se expressamente estabelecido no presente
          Contrato, o Estabelecimento não tem nenhum direito, título ou
          participação em ou em relação aos Direitos de Propriedade Intelectual
          subsistentes nos Serviços. Para fins do presente Contrato, “Direitos
          de Propriedade Intelectual” significam todas as invenções (sejam
          patenteadas ou não), direitos de design, direitos de bancos de dados,
          direitos autorais, direitos morais, direitos de topografia de
          semicondutor, marcas registradas e de serviço, logotipos, razão social
          e nomes comerciais, em cada caso, goodwill inerente a eles, todos os
          direitos de propriedade intelectual, know-how, e quaisquer direitos ou
          formas de proteção de natureza similar e com efeito equivalente ou
          similar a quaisquer deles que subsistem em qualquer lugar do mundo.
        </CardText>

        <CardText className="mb-2">
          <strong>6.2.</strong> A <strong>ULTRA PAYMENTS</strong> concede ao
          Estabelecimento uma licença pessoal, não exclusiva, revogável e
          intransferível de uso da Propriedade Intelectual subsistente nos
          Serviços, exclusivamente para fins de aceitação e recebimento de
          pagamentos, de acordo com este Contrato.
        </CardText>

        <CardText className="mb-2">
          <strong>6.3.</strong> O Estabelecimento não poderá:
          <ul>
            <li>(i) ceder, sublicenciar, copiar ou distribuir os Serviços;</li>
            <li>(ii) permitir que terceiros utilizem os Serviços.</li>
          </ul>
        </CardText>

        <CardText className="mb-2">
          <strong>6.4.</strong> Exceto se permitido por lei e com a autorização
          expressa da <strong>ULTRA PAYMENTS</strong>, o Estabelecimento não
          poderá adaptar, fazer engenharia reversa, decompilar, desmontar,
          modificar, adaptar ou corrigir erros nos Serviços.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          7. DECLARAÇÕES E GARANTIAS
        </CardText>

        <CardText className="mb-2">
          <strong>7.1. Declarações e Garantias do Estabelecimento</strong>
        </CardText>

        <CardText className="mb-2">
          <strong>7.1.1.</strong> O Estabelecimento declara e garante à{' '}
          <strong>ULTRA PAYMENTS</strong> que:
          <ul>
            <li>
              (i) tem no mínimo 18 anos de idade ou está legalmente constituído
              no Brasil e sob a legislação brasileira vigente, conforme o caso;
            </li>
            <li>(ii) é residente ou possui sede no Brasil; e</li>
            <li>
              (iii) possui o direito legal e plenos poderes e autoridade para
              celebrar o presente Contrato e cumprir suas obrigações nos seus
              termos, sem violar quaisquer outros compromissos que tenha
              assumido previamente a este Contrato.
            </li>
          </ul>
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          7.2. Declarações e Garantias da SUB
        </CardText>

        <CardText className="mb-2">
          <strong>7.2.1.</strong> Os Serviços serão fornecidos com o intuito de
          possibilitar o acesso integral pelo Estabelecimento, ressalvados
          eventuais impedimentos que possam vir a afetar a disponibilidade dos
          Serviços, conforme item 1.3., acima.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          8. RESPONSABILIDADES
        </CardText>

        <CardText className="mb-2">
          <strong>8.1. Limitação de Responsabilidade</strong>
        </CardText>

        <CardText className="mb-2">
          <strong>8.1.1</strong> Quando o Estabelecimento for o receptor dos
          fundos:
          <ul>
            <li>
              (a) a <strong>ULTRA PAYMENTS</strong> é responsável perante o
              Estabelecimento a corrigir a transmissão das ordens de pagamento
              ao prestador de serviços de pagamento do cliente do
              Estabelecimento (por exemplo, a emissora de cartão do cliente do
              Estabelecimento);
            </li>
            <li>
              (b) Se a <strong>ULTRA PAYMENTS</strong> falhar em transmitir uma
              ordem de pagamento corretamente, ela fará a retransmissão imediata
              de tal ordem de pagamento. Caso o Estabelecimento solicite
              informações relacionadas à transação de pagamento, então a{' '}
              <strong>ULTRA PAYMENTS</strong> envidará seus esforços para
              rastrear a transação e notificará o cliente em questão a respeito
              do resultado. Quando relevante, a <strong>ULTRA PAYMENTS</strong>{' '}
              será responsável perante o Estabelecimento por quaisquer encargos
              pelos quais o Estabelecimento for responsável ou por quaisquer
              taxas ou juros que o Estabelecimento deva pagar como consequência
              da falha ou da execução incorreta do pagamento. A{' '}
              <strong>ULTRA PAYMENTS</strong> não se responsabiliza, nos termos
              deste item, caso a falha em transmitir corretamente uma ordem de
              pagamento tenha se dado devido a circunstâncias inevitáveis,
              anormais ou imprevisíveis além de seu controle, sobretudo caso
              fortuito ou força maior, ou devido à exigência de lei ou
              regulamento aplicável, ou por determinação das BANDEIRAS ADMITIDAS
              e/ou de credenciadora/adquirente.
            </li>
          </ul>
        </CardText>

        <CardText className="mb-2">
          <strong>8.1.2</strong> Quando o Estabelecimento for o depositante dos
          fundos:
          <ul>
            <li>
              (a) Caso alguma pessoa, que não o Estabelecimento, utilize os
              detalhes de segurança do Leitor de Cartão e/ou da CONTA ULTRA
              PAYMENTS do Estabelecimento para efetuar transações não
              autorizadas pelo Estabelecimento a partir da CONTA ULTRA PAYMENTS
              do Estabelecimento (por exemplo, realizar restituições não
              autorizadas aos clientes do Estabelecimento), a{' '}
              <strong>ULTRA PAYMENTS</strong> não será responsabilizada pela
              transação indevida. Nesses casos, faculta-se ao Estabelecimento,
              por meio do pagamento de uma taxa, cujo valor pode ser consultado
              por meio do acesso à área restrita do Estabelecimento no Site,
              devida em razão de eventuais que a <strong>ULTRA PAYMENTS</strong>{' '}
              possa vir a incorrer em razão da operação não autorizada. Contudo,
              caso o Estabelecimento tenha atuado de maneira fraudulenta ou com
              intenção de fraudar ou com negligência intencional ou com falha no
              cumprimento de suas obrigações de segurança, então o
              Estabelecimento será responsável por todos os prejuízos
              incorridos, mesmo que superiores ao valor da taxa mencionada;
            </li>
            <li>
              (b) Em circunstâncias em que a <strong>ULTRA PAYMENTS</strong>{' '}
              tenha realizado uma transação de pagamento não autorizada e que
              não se enquadre no parágrafo anterior (por exemplo, na hipótese de
              a <strong>ULTRA PAYMENTS</strong> restituir, para um cliente do
              Estabelecimento, fundos, sem o consentimento do Estabelecimento),
              o Estabelecimento deve notificar a <strong>ULTRA PAYMENTS</strong>{' '}
              imediatamente, em até 3 (três) meses contados da data do débito na
              conta do cliente do Estabelecimento. Se não houver nenhuma prova
              de que o Estabelecimento tenha de fato autorizado a transação do
              pagamento, a <strong>ULTRA PAYMENTS</strong> restituirá o valor da
              transação de pagamento não autorizada ao Estabelecimento. Caso o
              Estabelecimento tenha iniciado uma ordem de pagamento (por
              exemplo, caso o Estabelecimento tenha feito uma ordem de pagamento
              para uma restituição a ser paga para um cliente do
              Estabelecimento), a <strong>ULTRA PAYMENTS</strong> será
              responsável perante o Estabelecimento pela execução correta da
              transação de pagamento, exceto se a{' '}
              <strong>ULTRA PAYMENTS</strong> puder comprovar que a prestadora
              de serviços de pagamento do titular do cartão (por exemplo, a
              emissora do cartão) tenha recebido a transação de pagamento. Em
              circunstâncias em que a <strong>ULTRA PAYMENTS</strong> for
              responsável, sem atraso, restituirá ao Estabelecimento o valor da
              transação de pagamento não realizada ou com defeito.
            </li>
          </ul>
        </CardText>

        <CardText className="mb-2">
          Exceto nas circunstâncias descritas acima, na máxima extensão
          permitida por lei, a <strong>ULTRA PAYMENTS</strong> não se
          responsabilizará perante o Estabelecimento, em virtude de contrato,
          ato ilícito (incorrido com culpa ou sem culpa) ou de outra forma nos
          termos ou em relação ao presente Contrato por nenhum(a):
          <ul>
            <li>
              perdas ou danos econômicos (incluindo, sem limitação, perda de
              receitas, lucros, contratos, negócios ou economias antecipadas);
            </li>
            <li>perda de reputação; ou</li>
            <li>perdas ou danos consequenciais, indiretos ou específicos.</li>
          </ul>
        </CardText>

        <CardText className="mb-2">
          <strong>8.1.3</strong> Na máxima extensão permitida por lei, a total
          responsabilidade da <strong>ULTRA PAYMENTS</strong>, seja decorrente
          de contrato (incluindo os termos de qualquer indenização ou garantia),
          ato ilícito (incluindo, sem limitações, negligência), de acordo com
          qualquer estatuto ou de outra forma nos termos ou em relação ao
          presente Contrato ou com a prestação dos Serviços, será limitada no
          máximo a R$ 20.000,00 (vinte mil reais) ou ao valor equivalente às
          taxas de serviço pagas à <strong>ULTRA PAYMENTS</strong> pelo
          Estabelecimento nos últimos dois meses, nos termos deste instrumento,
          o que for menor.
        </CardText>

        <CardText className="mb-2">
          <strong>8.2. Indenização</strong>
        </CardText>

        <CardText className="mb-2">
          <strong>8.2.1</strong> O Estabelecimento concorda que indenizará a{' '}
          <strong>ULTRA PAYMENTS</strong> contra quaisquer perdas, danos, custos
          e despesas incorridos por ou imputados contra a{' '}
          <strong>ULTRA PAYMENTS</strong> em relação a qualquer reivindicação de
          terceiros decorrente ou em relação ao uso pelo Estabelecimento dos
          Serviços, exceto se em conformidade com este Contrato.
        </CardText>

        <CardText className="mb-2">
          <strong>8.2.2</strong> Em caso de quaisquer processos judiciais em
          desfavor da <strong>ULTRA PAYMENTS</strong> em relação aos Serviços,
          se a <strong>ULTRA PAYMENTS</strong> vier a indenizar o reclamante, o
          Estabelecimento terá que restituir em todos os gastos, inclusive com
          advogados que vierem a ser contratados pela{' '}
          <strong>ULTRA PAYMENTS</strong>, se ficar comprovada a
          responsabilidade do Estabelecimento.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          9. CONTROVÉRSIAS
        </CardText>

        <CardText className="mb-2">
          <strong>9.1</strong> Caso o Estabelecimento tenha qualquer reclamação
          sobre os serviços da <strong>ULTRA PAYMENTS</strong>, o
          Estabelecimento poderá entrar em contato com a Central de Atendimento
          da <strong>ULTRA PAYMENTS</strong>, cujos dados para contato
          encontram-se descritos no Site, ou enviar um e-mail para suporte@ULTRA
          PAYMENTScom.br em primeira instância, garantindo a realização de uma
          análise sobre a reclamação e que os resultados serão comunicados ao
          Estabelecimento em tempo hábil.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          10. DISPOSIÇÕES GERAIS
        </CardText>

        <CardText className="mb-2">
          <strong>10.1 Alterações</strong>
        </CardText>

        <CardText className="mb-2">
          <strong>10.1.1</strong> Conforme mencionado no item 1.2.1., a{' '}
          <strong>ULTRA PAYMENTS</strong> se reserva o direito de alterar este
          Contrato a qualquer momento. O Estabelecimento deverá aceitar as
          alterações antes de processar quaisquer transações futuras. Caso não
          queira aceitar qualquer alteração nos termos, o Estabelecimento terá o
          direito de rescindir o presente Contrato. O uso continuado dos
          Serviços pelo Estabelecimento após a notificação das alterações será
          considerado como uma confirmação de sua aceitação das alterações do
          Contrato.
        </CardText>

        <CardText className="mb-2">
          <strong>10.1.2</strong> O layout, a forma e a redação do(s) website(s)
          ou telas pelos quais o Estabelecimento acessa sua conta{' '}
          <strong>ULTRA PAYMENTS</strong>, e as próprias telas das contas{' '}
          <strong>ULTRA PAYMENTS</strong> estão sujeitos a alterações pela{' '}
          <strong>ULTRA PAYMENTS</strong> a qualquer momento. A{' '}
          <strong>ULTRA PAYMENTS</strong> poderá realizar tais alterações sem
          nenhuma notificação prévia ao Estabelecimento.
        </CardText>

        <CardText className="mb-2">
          <strong>10.2. Invalidade dos Termos</strong>
        </CardText>

        <CardText className="mb-2">
          <strong>10.2.1</strong> Caso qualquer disposição do presente Contrato
          seja inexequível de qualquer forma, tal fato não afetará a validade
          dos demais termos ou itens de forma alguma. A{' '}
          <strong>ULTRA PAYMENTS</strong> poderá ocasionalmente permitir ao
          Estabelecimento um tempo extra para o cumprimento de suas obrigações
          ou decidir não exercer alguns de seus direitos, desde que justificado
          o motivo. Entretanto, a <strong>ULTRA PAYMENTS</strong> pode ainda
          insistir na aplicação restrita do presente Contrato posteriormente.
        </CardText>

        <CardText className="mb-2">
          <strong>10.3. Comunicações</strong>
        </CardText>

        <CardText className="mb-2">
          <strong>10.3.1</strong> As declarações, notificações, divulgações e
          outras comunicações a serem fornecidos pela{' '}
          <strong>ULTRA PAYMENTS</strong> ao Estabelecimento nos termos do
          presente Contrato (incluindo quaisquer alterações nos termos e
          condições do presente Contrato) serão feitas por escrito, por e-mail
          ou eletronicamente por meio da CONTA <strong>ULTRA PAYMENTS</strong>{' '}
          do Estabelecimento.
        </CardText>

        <CardText className="mb-2">
          <strong>10.3.2</strong> O Estabelecimento deve manter um endereço
          postal válido e uma conta de e-mail durante a vigência do presente
          Contrato. O Estabelecimento deve informar à{' '}
          <strong>ULTRA PAYMENTS</strong> imediatamente em caso de alteração do
          endereço ou outra informação de contato fornecida à{' '}
          <strong>ULTRA PAYMENTS</strong>. A <strong>ULTRA PAYMENTS</strong> não
          se responsabilizará por nenhuma falha por parte do Estabelecimento em
          receber um comunicado enviado pela <strong>ULTRA PAYMENTS</strong> no
          endereço do Estabelecimento ou outra informação de contato fornecida
          pelo Estabelecimento.
        </CardText>

        <CardText className="mb-2">
          <strong>10.4. Idioma</strong>
        </CardText>

        <CardText className="mb-2">
          <strong>10.4.1</strong> O presente Contrato é escrito e
          disponibilizado apenas em português e o Estabelecimento concorda que
          todas as comunicações entre o Estabelecimento e a{' '}
          <strong>ULTRA PAYMENTS</strong> serão feitas em português.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          10.5. Cessão
        </CardText>

        <CardText className="mb-2">
          <strong>10.5.1</strong> O Estabelecimento não poderá ceder, novar ou
          de outra forma transferir nenhum de seus direitos ou obrigações nos
          termos do presente Contrato a nenhuma pessoa sem o consentimento
          prévio e por escrito da <strong>ULTRA PAYMENTS</strong>.
        </CardText>

        <CardText className="mb-2">
          <strong>10.5.2</strong> O Estabelecimento concorda que a{' '}
          <strong>ULTRA PAYMENTS</strong> poderá ceder, novar ou de outra forma
          transferir todos e quaisquer de seus direitos e obrigações nos termos
          do presente Contrato a outra empresa a qualquer momento, sem nenhuma
          necessidade de consentimento prévio do Estabelecimento.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          10.6. Acordo Integral
        </CardText>

        <CardText className="mb-2">
          <strong>10.6.1</strong> O presente Contrato constitui o acordo
          integral entre as partes e substitui todas as minutas, contratos,
          acordos ou entendimentos anteriores entre as partes, sejam por escrito
          ou verbalmente, relacionados ao objeto deste instrumento.
        </CardText>

        <CardText className="mb-2">
          <strong>10.6.2</strong> Cada uma das partes concorda que, ao celebrar
          o presente Contrato, não confiaram em e não lhe caberão nenhum recurso
          a respeito de qualquer declaração ou garantia (seja feita inocente ou
          negligentemente) que não estejam estabelecidas no presente Contrato.
        </CardText>

        <CardText className="mb-2">
          <strong>10.6.3</strong> Nenhuma disposição deste item 10.6. limitará
          ou excluirá qualquer responsabilidade por fraude ou declaração
          enganosa e/ou fraudulenta.
        </CardText>

        <CardText className="mb-2">
          <strong>10.6.4</strong> Ao aceitar os termos e condições deste
          Contrato, a <strong>ULTRA PAYMENTS</strong> enviará uma cópia do
          Contrato para o endereço de e-mail cadastrado do Estabelecimento.
        </CardText>

        <CardText className="mb-2">
          <strong>10.6.5</strong> A versão mais recente do presente Contrato
          pode ser visualizada no Site. Mediante a solicitação do
          Estabelecimento, a <strong>ULTRA PAYMENTS</strong> fornecerá ao menos
          uma cópia impressa do presente Contrato.
        </CardText>

        <CardText tag="h5" className="font-weight-bold">
          10.7. Lei de Regência e Foro
        </CardText>

        <CardText className="mb-2">
          <strong>10.7.1</strong> As partes, renunciando a qualquer outro por
          mais privilegiado que seja, elegem o Foro Central da Comarca de São
          Paulo para dirimir eventuais litígios decorrentes do presente
          Contrato.
        </CardText>

        <CardText className="mb-2">***</CardText>
      </article>
    </>
  );
};
